import React, { useState } from "react";
import Accuracy_table from "./accuracy_table/Accuracy_table";
import Accuracy_Form from "./accuracy_Form/Accuracy_Form";

function Accuracy() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Accuracy_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Accuracy_table/>
        </div>
      )}
    </>
  );
}

export default Accuracy;
